// Copyright (c) 2017 Deere & Company

import Dealers from '../state/labor-rates';
import actions from '../../action-list';
import {getDefaultState} from '../state';
import {updateList} from '../../../shared/services/list-selections';

const updateListSelected = (state, action) =>
    Dealers.update(state, {
        $set: updateList(
            action.dealer,
            action.isSelected,
            'account',
            state
        )
    });

const updateAllDealerAccounts = (state, action) => {

    const toggledStatuses = state.length ?
            [] :
            action.dealers;

    return Dealers.update(state, {
        $set: toggledStatuses
    });

};

const resetClaimSelectedDealers = state =>

    Dealers.update(state, {
        $set: []
    });

export default (state = getDefaultState().selectedDealers, action) => {

    const actionTypes = {
        [actions.UPDATE_SELECTED_DEALER_ACCOUNTS]: updateListSelected,
        [actions.UPDATE_SELECTED_ALL_DEALER_ACCOUNTS]: updateAllDealerAccounts,
        [actions.RESET_CLAIM_SELECTED_DEALERS]: resetClaimSelectedDealers
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/reducers/dealers-selected.js